//
// JS for the Ohio Rx Report selection page
//
goog.require('el8.app.setup');
goog.require('el8.data.practiceUsers');
goog.require('el8.service.infoField');
goog.require('el8.service.tz');
goog.require('el8.service.urls');
goog.require('el8.uiwidget.addDatepicker');
goog.require('el8.uiwidget.alert');
goog.require('el8.util.datecompare');

var el8 = el8 || {};
if(!el8.main) { el8.main = {}; }

el8.main.appRxReportOH = {
    fromDateInfoField: null,
    toDateInfoField: null
};

el8.main.appRxReportOH._getParams = function() {
    var from_str = this.fromDateInfoField.getVal() || null;
    var to_str = this.toDateInfoField.getVal() || null;

    return {
        'physicianId': $('#rx-report-physician-select').val() || null,
        'start_date': from_str ? from_str.replace(/\//g, "") : null,
        'end_date': to_str ? to_str.replace(/\//g, "") : null
    };
};

el8.main.appRxReportOH.init = function(spec) {
    var that = this;

    spec['layout'] = {innerContainerSelector: '#rx-report-container'};
    el8.app.setup(spec);

    el8.data.practiceUsers.load();

    // setup infoFields and datePickers
    this.fromDateInfoField = el8.service.infoField.addInfoField({
        field: $('#rx-report-date-from')
    });

    el8.uiwidget.addDatepicker(this.fromDateInfoField, {
        // The selectable date range is one day less than the given date,
        // so if we want the user to select up to yesterday, this has to
        // be set to today.
        maxDate: el8.service.tz.today()
    });
    this.fromDateInfoField.setVal(el8.service.tz.yesterday().asString());

    this.toDateInfoField = el8.service.infoField.addInfoField({
        field: $('#rx-report-date-to')
    });
    el8.uiwidget.addDatepicker(this.toDateInfoField, {
        maxDate: el8.service.tz.today()
    });
    this.toDateInfoField.setVal(el8.service.tz.yesterday().asString());

    //
    // triggers
    //
    $(document).on('click', '.print-trigger',  function(e) {
        var params = that._getParams();
        var url = el8.service.urls.get('rxReport',
                                               [params['physicianId'],
                                                params['start_date'],
                                                params['end_date']]);

        var printPath = url + '/print';
        window.open(printPath);
    });
};
